export default {
  data() {
    return {
      isAndroidBtn: false
    };
  },
  computed: {
    btns() {
      const result = [];
      const __btns = [
        // {
        //   name: "android",
        //   img: this.logoImgs.android,
        //   zhName: `立即下载`,
        //   en: {
        //     tips: 'https://img.tinhnow.com/wownow/static/wownow-download/get-it-on.png',
        //     tipsClass: "get-it-on",
        //     tipsContent: 'GET IT ON',
        //     content: "Android",
        //   },
        //   click: this.officialClick,
        //   show: !this.isIOS
        // },
        {
          name: "android",
          img: this.logoImgs.android,
          zhName: `安卓渠道下载`,
          kmName: 'ទាញយក​កម្មវិធីតាម Android',
          en: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/get-it-on.png',
            tipsClass: "get-it-on",
            tipsContent: 'GET IT ON',
            content: "Android"
          },
          km: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/get-it-on.png',
            tipsClass: "get-it-on",
            tipsContent: 'បើកដំណើរការ',
            content: "Android"
          },
          click: this.androidClick,
          show: !this.isAndroidBtn
        },
        {
          name: "phoneHome",
          img: this.logoImgs.android,
          zhName: `官方渠道下载`,
          kmName: 'ទាញយក​កម្មវិធីតាម App ផ្លូវការ',
          en: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/i-have-no-google.png',
            tipsClass: "i-have-no-google",
            tipsContent: 'I have no google',
            content: "Official Site"
          },
          km: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/i-have-no-google.png',
            tipsClass: "i-have-no-google",
            tipsContent: 'ខ្ញុំមិនមាន Google',
            content: "Official Site"
          },
          click: this.officialClick,
          show: this.isAndroidBtn
        },
        {
          name: "apple",
          img: this.logoImgs.apple,
          zhName: `苹果商店下载`,
          kmName: 'ទាញយកកម្មវិធីតាម iOS',
          en: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/download-on-the.png',
            tipsClass: "download-on-the",
            tipsContent: 'Download on the',
            content: "App Store"
          },
          km: {
            tipsClass: "download-on-the",
            tipsContent: 'ទាញយកនៅលើ',
            content: "App Store"
          },
          click: this.appleClick,
          show: !this.isAndroidBtn
        },
        {
          name: "google",
          img: this.logoImgs.google,
          zhName: `谷歌市场下载`,
          kmName: 'ទាញយកតាម​ Google Play',
          en: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/get-it-on.png',
            tipsClass: "get-it-on",
            tipsContent: 'GET IT ON',
            content: "Google Play"
          },
          km: {
            // tips: 'https://img.tinhnow.com/wownow/static/wownow-download/get-it-on.png',
            tipsClass: "get-it-on",
            tipsContent: 'ទទួលបានវានៅលើ',
            content: "Google Play"
          },
          click: this.googleClick,
          show: this.isAndroidBtn
        }
      ];
      for (let i = __btns.length - 1; i >= 0; i--) {
        result.push(__btns[i]);
      }
      return result;
    },
    logoImgs() {
      return {
        blueMenuImageSrc: 'https://img.tinhnow.com/wownow/static/wownow-download/blue-menu.png',
        blueButtonImageSrc: 'https://img.tinhnow.com/wownow/static/wownow-download/blue-button.png',
        earthImageSrc: 'https://img.tinhnow.com/wownow/static/wownow-download/earth.png',
        google: {
          src: 'https://img.tinhnow.com/wownow/static/wownow-download/google-logo.png'
          // style: "width: 0.7rem;padding-top: 0.08rem;",
        },
        android: {
          src: 'https://img.tinhnow.com/wownow/static/wownow-download/android-logo.png'
          // style: "width: 0.67rem;",
        },
        apple: {
          src: 'https://img.tinhnow.com/wownow/static/wownow-download/apple-logo.png'
          // style: "width: 0.67rem;padding-top: 0.08rem;",
        }
      };
    },
    downLoad() {
      return window?.ssrConfig?.routerConfig?.downLoad ?? {};
    }
  },
  methods: {
    androidClick() {
      this.checkMasking(isOpenClick => {
        console.log("isOpenClick: ", isOpenClick)
        console.log(this.isAndroid)
        // alert(navigator.userAgent.toLocaleLowerCase())
        // alert(navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1)
        if (this.isAndroid && isOpenClick) {
          this.isAndroidBtn = true;
        }
      });
    },
    appleClick() {
      this.checkMasking(isOpenClick => {
        if (this.isIOS && isOpenClick) {
          const appleLint = this.downLoad?.apple;
          // window.location.href = appleLint || 'itms-apps://itunes.apple.com/app/id1507128993';
          window.location.href = appleLint || 'itms-appss://itunes.apple.com/app/id1507128993';
        }
      });
    },
    googleClick() {
      this.checkMasking(isOpenClick => {
        if (this.isAndroid && isOpenClick) {
          const googleLint = this.downLoad?.google;
          window.location.href = googleLint || 'https://play.google.com/store/apps/details?id=com.chaos.superapp';
        }
      });
    },
    officialClick() {
      this.checkMasking(isOpenClick => {
        if (this.isAndroid && isOpenClick) {
          this.isShowDownload = true;
          const officialLint = ssrConfig?.routerConfig?.appDownload.packageLink ?? 'https://img.tinhnow.com/wownow/files/pro/app/M50/4B/3/651327ad7d9e4438a38eeab66a3bdcef.apk';
          console.log('official link')
          console.log(officialLint)
          setTimeout(() => {
            window.location.href = officialLint;
          }, 500)
          // window.location.href = 'https://img.tinhnow.com/wownow/files/app/M50/50/4B/3/17245470ef6e11ebbb2c8ba18d207e1a.apk';
        }
      });
    }
  }
}
